import { useMutation } from '@hooks/reactQuery';

import { generateApiDocumentation } from '@api/reports';

import { TOnSuccessOnError } from '@interfaces/common/handlers';
import { IApiDocumentationParams } from '@interfaces/platform/dto/reportDTO';

import { API_DOCUMENTATION } from '@constants/queryKeys';

export interface IUseApiDocumentationReturn extends Partial<TOnSuccessOnError> {
	isLoading: boolean;
	generateApiDocumentation: (params: IApiDocumentationParams) => Promise<void>;
}

export function useApiDocumentation(
	onSuccess?: () => void,
	onError?: () => void,
): IUseApiDocumentationReturn {
	const {
		isLoading,
		mutateAsync,
	} = useMutation<IApiDocumentationParams>({
		mutationFn: generateApiDocumentation,
		mutationKey: [API_DOCUMENTATION],
		onSuccess,
		onError,
	});

	return {
		isLoading,
		generateApiDocumentation: mutateAsync,
	};
}
